import React from 'react';

import TableSelectMap from '../TableSelectMap';
import ItemListForm from '../../components/form/ItemListForm';
import { View, StyleSheet } from 'react-native';
import SwipedView from '../swipe/SwipedView';
import { type TableMapType, type TableType } from '../../types/Table';
import SwipedViewItem from '../swipe/SwipedViewItem';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 16,
        paddingTop: 30,
        backgroundColor: '#fff',
    },
});

interface Props {
    tableList: TableType[];
    tableMapList: TableMapType[];
    setFieldValue?: (data: TableType) => void;
    disabled: boolean;
}

const TableSelectArea: React.FC<Props> = ({
    tableList,
    tableMapList,
    setFieldValue,
    disabled,
}) => {
    const [width, setWidth] = React.useState(0);

    const { t } = useTranslation();

    return (
        <View style={styles.container}>
            {tableMapList.length > 0 ? (
                <SwipedView setWidth={setWidth}>
                    {tableMapList.map((tableMap, index) => (
                        <SwipedViewItem key={index} width={width}>
                            <TableSelectMap
                                tableMap={tableMap}
                                setFieldValue={setFieldValue}
                            />
                        </SwipedViewItem>
                    ))}
                </SwipedView>
            ) : (
                <ItemListForm
                    tableList={tableList}
                    setFieldValue={setFieldValue}
                    disabled={disabled}
                    title={t('table')}
                />
            )}
        </View>
    );
};

export default TableSelectArea;
